export default __webpack_public_path__ + "f73c71a378f0f63f4386ccdef8241fda.png";